import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { PartnerPortalSettings } from 'src/app/interfaces/partner-portal/partner-portal-settings';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { SettingsService } from 'src/app/services/settings.service';
import { environment } from 'src/environments/environment';
import { PartnerPortalInfoBlocksComponent } from 'src/app/components/partner-portal/partner-portal-info-blocks/partner-portal-info-blocks.component';

@Component({
    selector: 'app-partner-portal-homepage',
    imports: [SharedModule, PartnerPortalInfoBlocksComponent],
    templateUrl: './partner-portal-homepage.component.html',
    styleUrl: './partner-portal-homepage.component.scss'
})
export class PartnerPortalHomepageComponent implements OnInit {
  id: string;
  id_bottom: string;

  constructor(private settingsService: SettingsService) {}

  ngOnInit(): void {
    this.settingsService.getSettings().subscribe((settings: PartnerPortalSettings) => {
      this.id = `${settings.home_page_cms_id}${environment.name !== 'production' ? '-test' : ''}`;
      this.id_bottom = settings.home_page_cms_id_bottom;
    });
  }
}
